import storage from 'good-storage'
import {CACHE_PREFIX} from "./config";

/**
 * args Object
 * [{key:function(){}}]
 */
export class validate {
  constructor(...args) {
    this.funs = [];
    this.validateFun = validateFun;
    if (args) {
      args.forEach((funObj) => {
        this.validateFun = Object.assign({}, this.validateFun, funObj);
      });
    }
  }

  add(value, ruleArr) {
    ruleArr.forEach((rule) => {
      this.funs.push({
        fun: this.validateFun[rule.shift()],
        msg: rule.shift(),
        params: [value].concat(rule)
      });
    })
    return this;
  }

  start() {
    for (let i = 0, rule; rule = this.funs[i++];) {
      if (rule.fun.apply(null, rule.params) === false) {
        return rule.msg;
      }
    }
  }
}

export class history {
  constructor() {
    this.key = CACHE_PREFIX + 'history';
    this.storage = storage.session;
  }

  remove(value) {
    let his = this.get(),
      index = his.findIndex(r => {
        if (typeof r === 'string') {
          return r === value;
        } else return r.value === value;
      });
    if (index >= 0) {
      his.splice(index, 1);
    }
    this.storage.set(this.key, his);
  }

  get() {
    return this.storage.get(this.key, []);
  }

  set(value) {
    let his = this.get(),
      index = his.findIndex(r => {
        if (typeof r === 'string') {
          return r === value;
        } else return r.value === value;
      });
    if (index >= 0) {
      his = his.slice(0, index + 1);
    } else {
      his.push({
        value,
        time: new Date().getTime()
      });
      let last1 = his[his.length - 1],
        last2 = his[his.length - 2];
      if (last1 && last2 && last1.time - last2.time < 1000) {
        his.splice(his.length - 2, 1);
      }
    }
    this.storage.set(this.key, his);
  }
}



// WEBPACK FOOTER //
// ./src/lib/class.js